export default __webpack_public_path__ + "static/media/ChakraPetch-Medium.e9045e1f.woff";